import { render, staticRenderFns } from "./chained-banner.vue?vue&type=template&id=0ab70955&scoped=true"
import script from "./chained-banner.vue?vue&type=script&lang=js"
export * from "./chained-banner.vue?vue&type=script&lang=js"
import style0 from "./chained-banner.vue?vue&type=style&index=0&id=0ab70955&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab70955",
  null
  
)

export default component.exports